type ResolveRosterAssignmentLockInput = {
  readonly isAssignmentLocked: boolean;
  readonly allowAssignmentLockedCellInteraction: boolean;
};

export function resolveRosterAssignmentLock({
  isAssignmentLocked,
  allowAssignmentLockedCellInteraction,
}: ResolveRosterAssignmentLockInput): boolean {
  return isAssignmentLocked && !allowAssignmentLockedCellInteraction;
}
